<svg viewBox="-1 -1 2 2" style="transform: rotate(-90deg); height: 200px; width: 200px;" #appendToChildEl>
</svg>
